import { message } from 'antd'
import { updateProject } from '../../../HttpRequests/projects'
import fetch from './fetch'
import handleException from '../../../Core/Helpers/handleException'

export default (id) => async (dispatch) => {

  try {

    await updateProject({
      id,
      data: {
        rams_muted: 1
      }
    })

    await dispatch(fetch())

    message.success('Muted')
    
  } catch (error) {

    handleException(error)

  }
  
}